module.exports = __webpack_public_path__ + "media/images/flags/64/Nepal-bd88de3e0b730a760ec1fe9836bdc577.png";